// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fkfD","label":"styles_label__3l_UY"};